import { useState } from "react";

export type UseFilterAddFunc = (name: string) => void;
export type UseFilterRemoveFunc = (id: number) => void;
export type UseFilterCleareAllFunc = () => void;

export function useFilters() {
  const [activeFilters, setActiveFilters] = useState<
    { name: string; id: number }[]
  >([]);

  const addFilter: UseFilterAddFunc = (filterName: string) => {
    setActiveFilters((prev) => {
      const isFilterExist = prev.some((filter) => filter.name === filterName);
      return isFilterExist ? prev : [...prev, { name: filterName, id: prev.length > 0 ? prev[prev.length - 1].id + 1 : 1 }];
    });
  };


  const removeFilter: UseFilterRemoveFunc = (id) => {
    setActiveFilters((prev) => [...prev.filter((item) => item.id !== id)]);
  };

  const clearAll: UseFilterCleareAllFunc = () => {
    setActiveFilters([])
  }

  return {
    activeFilters: activeFilters,
    addFilter: addFilter,
    removeFilter: removeFilter,
    clearAll: clearAll
  };
}
